import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

import {  OnlineSettings } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const RestaurantSettings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        {/* <Grid
          item
          md={7}
          xs={12}
        >
          <Notifications />
        </Grid> */}
        <Grid
          item
          md={12}
          xs={12}
        >
          <OnlineSettings />
        </Grid>
      </Grid>
    </div>
  );
};

export default RestaurantSettings;
